// **** Editar Colaborador ****
// **** autor: Walcledson de Paula ****
// ******** data: 11/10/24 19h16
// ******** data: 14/10/24 16h32 | conslusão do código, incluindo a foto do colaborador (se houver)
// **** p_colaborador_editar.jsx
// ***********************************
 


import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import apiaxios from "../../../../../Services/apiaxios.js";
import InputMask from 'react-input-mask';
import { p_getUserData } from "../../../../../Services/p_userutils.js";
import Swal from 'sweetalert2';
// import { Row, Col, Button } from 'react-bootstrap'; // Certifique-se de importar os componentes corretamente
import { Spinner } from 'react-bootstrap'; // Você pode usar um spinner de alguma biblioteca de UI, como Bootstrap ou Material-UI
import Icon from '@mdi/react';
import { mdiArrowLeftCircle } from '@mdi/js';
import withReactContent from 'sweetalert2-react-content';
import handleApiError from "../../../../../Services/apiErrorHandler.js";
import { decrypt } from "../../../../../Services/cryptoUtils.js";
import { AutoLogout } from "../../../../../Services/autologout.js";

import Menu from "../../../Components/Menu/p_menu.jsx";
import Footer from "../../../../AgendexCliente/components/Footer/footer.jsx";

import './p_colaboradores.css';

function ColaboradorEditar() {
    // console.log('colaborador :', colaborador);
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenlg = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, [tokenASW]);

    const initialUserData = p_getUserData();
    const [id_usuario, setId_usuario] = useState(initialUserData.userId); // Usar setIdUsuario para atualizar o id_usuario
    const colaborador = useLocation();
    const colaboradorData = colaborador.state;
    const [id_colaborador] = useState(colaboradorData.colaborador.COL_ID || 0);
    const [nome] = useState(colaboradorData.colaborador.COL_NOME || '');
    const [especialidade, setEspecialidade] = useState(colaboradorData.colaborador.COL_ESPECIALIDADE || '');
    const [percentualComissao, setPercentualComissao] = useState(colaboradorData.colaborador.COL_PERCENTUAL_COMISSAO || '');
    const [email] = useState(colaboradorData.colaborador.COL_EMAIL || '');
    const [fone, setFone] = useState(colaboradorData.colaborador.COL_FONE || '');
    const [dtcadastro] = useState(colaboradorData.colaborador.COL_DATACADASTRO || '');
    const [fotoPerfil, setFotoPerfil] = useState(null);
    const [isEditable, setIsEditable] = useState(false);
    const [salvar, setSalvar] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const navigate = useNavigate();

    const foneRef = useRef(null);
    const MySwal = withReactContent(Swal);

    useEffect(() => {
        carregaFoto(colaboradorData.colaborador.COL_ID);
    }, []);

    const carregaFoto = async (id_colaborador) => {
        setLoading(true);
        try {
            const response = await apiaxios.get('/colaborador/fotoPerfilMiniWeb', {
                params: { id_usuario,
                        token: tokenASW,
                        id_colaborador
                }
            });
            if (response.status === 200) {
                const data = response.data;
                // console.log (data);
                if (data.retorno === 'OK') {
                    setFotoPerfil(`data:image/jpeg;base64,${data.foto}`);
                } else {
                    Swal.fire('Erro', data.retorno, 'error');
                }
            } else {
                Swal.fire('Erro', 'Falha ao carregar os dados de sua empresa. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleEditProfile = () => {
        setIsEditable(true);
        setSalvar(true);
        setTimeout(() => {
            if (foneRef.current && foneRef.current.inputElement) {
                foneRef.current.inputElement.focus();
            }
        }, 0);
    };

    const handleCancelEdit = () => {
        setIsEditable(false);
        setSalvar(false);
    };

    const validatePhone = (input) => {
        return input.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const result = await MySwal.fire({
            title: 'Confirmação!',
            text: "Você confirma alteração dos dados deste Colaborador ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, alterar!',
            cancelButtonText: 'Cancelar!'
        });

        if (result.isConfirmed) {
            try {
                const response = await apiaxios.put('/empresa/colaboradorCRUDWeb', {
                    id_empresa: id_usuario,
                    id_colaborador,
                    nome,
                    especialidade,
                    percentualComissao, 
                    email,
                    fone
                },
                {
                    params: { token: tokenASW,
                            id_usuario }
                });
                if (response.status === 200) {
                    MySwal.fire('Sucesso', 'Dados do Colaborador alterados com sucesso!', 'success');
                    navigate('/app/prestador/empresa/colaboradores');
                } else {
                    MySwal.fire('Erro', 'Falha ao alterar dados do Colaborador. Tente novamente mais tarde.', 'error');
                }
            } catch (error) {
                const errorMessage = error.response?.data?.retorno || 'Erro de conexão. Verifique sua conexão e tente novamente.';
                MySwal.fire('Erro', errorMessage, 'error');
            }
        } else {
            handleCancelEdit()
        }
    };

    const parseCurrency = (value) => {
        // Garantir que value seja uma string
        if (typeof value !== 'string') {
            // Se não for string, converter para string
            value = String(value);
        }
        // Remover pontos e converter vírgula para ponto
        return parseFloat(value.replace(/\./g, '').replace(',', '.'));
    };

    const handleBackClick = () => {
        navigate('/app/prestador/empresa/colaboradores'); // Redireciona para uma página padrão se "from" não estiver definido
    };

  


    return (
        <div>
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                        <Menu page="colaboradores" />
                    </div>
                    <div className="col py-3 me-3">
                        <div className="text-center">
                            <h1>Alterar dados do Colaborador</h1>
                        </div>
                        <hr />

                        {loading ? (
                            <div className="text-center">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Carregando foto...</span>
                                </Spinner>
                            </div>
                            ) : (
                            <div className="col py-3 me-3">
                                <div className="img-usuario text-center">
                                    {/* <img src={fotoPerfil} className="usuario-foto" alt="( sem foto colaborador )" onClick={() => setShowCardFotoPerfil(true)} /> */}
                                    <img src={fotoPerfil} className="usuario-foto" alt="( sem foto colaborador )" />
                                </div>
                            </div>
                        )}

                        <div className="box-perfil">
                            <form>
                                <hr />
                                <div className="row mb-3">
                                    <label htmlFor="perfilnome" className="col-sm-2 col-form-label">Nome / id: {colaboradorData.colaborador.COL_ID}</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className="form-control" id="perfilnome" placeholder="Nome do funcionário/ colaborador" autoComplete="username" value={nome} />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <label htmlFor="perfilespecialidade" className="col-sm-2 col-form-label">Especialidade</label>
                                    <div className="col-sm-10">
                                        <input disabled={!isEditable} type="text" className="form-control" id="perfilespecialidade" placeholder="Especialidade ou serviço predominante" autoComplete="username" value={especialidade} 
                                            onChange={(e) => setEspecialidade(e.target.value.toUpperCase())}
                                        />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <label htmlFor="perfilcomissao" className="col-sm-2 col-form-label">% Comissão</label>
                                    <div className="col-sm-10">
                                        {/* <input disabled={!isEditable} type="number" className="form-control" id="perfilcomissao" placeholder="percentual de comissão do colaborador" autoComplete="perfilcomissao" 
                                        // value={percentualComissao} 
                                            value={parseCurrency(percentualComissao)}
                                            onChange={(e) => setPercentualComissao(e.target.value)}
                                        /> */}
                                        <InputMask
                                            disabled={!isEditable}
                                            mask={"99,99"}
                                            maskChar=""
                                            type="numeric"
                                            name="percentualComissao"
                                            className="form-control"
                                            id="percentualComissao"
                                            placeholder="Comissão (ex: 15.50)"
                                            autoComplete="percentualComissao"
                                            value={parseCurrency(percentualComissao)}
                                            // onChange={handleInputChange}
                                            onChange={(e) => setPercentualComissao(e.target.value)}
                                            step="0.01" // permite até duas casas decimais
                                            min="0"
                                            max="100"
                                        />                                    
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <label htmlFor="perfilemail" className="col-sm-2 col-form-label">Email válido</label>
                                    <div className="col-sm-10">
                                        <input disabled type="email" className="form-control" id="perfilemail" placeholder="Email preferencial do colaborador/ funcionário" autoComplete="email" value={email} />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <label htmlFor="perfilfone" className="col-sm-2 col-form-label">Telefone preferencial(celular)</label>
                                    <div className="col-sm-10">
                                        <InputMask
                                            mask={'(99)99999-9999'}
                                            disabled={!isEditable}
                                            type="numeric"
                                            className="form-control"
                                            id="perfilfone"
                                            placeholder="Telefone (preferencial WhatsApp)"
                                            autoComplete="fone"
                                            value={fone}
                                            onChange={(e) => setFone(validatePhone(e.target.value))}
                                            ref={foneRef}
                                        />                                    
                                    </div>
                                </div>

                                
                                <hr />

                                <div className="row mb-3">
                                    <label htmlFor="perfidtcadastro" className="col-sm-2 col-form-label">Data de Cadastro</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className="form-control" id="perfidtcadastro" placeholder="Data do cadastrado realizado no Agendex" autoComplete="datacadastro" value={dtcadastro} />
                                    </div>
                                </div>

                            </form>
                        </div>
                        <div className="d-flex justify-content-between">
                            <button type="button" className="btn btn-primary" onClick={handleEditProfile} disabled={isEditable}>Alterar dados do Colaborador</button>
                            <button type="button" className="btn btn-danger" onClick={handleSubmit} disabled={!isEditable}>Salvar alterações</button>
                            <button className="btn btn-secondary" onClick={handleBackClick}>
                                    <Icon path={mdiArrowLeftCircle} size={1}/> {!isMobile && 'Cancelar'}
                                </button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default ColaboradorEditar;